export default __webpack_public_path__ + "static/media/chevron-down.inline.0d03f8ef.svg";